export enum AdditionTransformControlMode {
    EnableTransformControl = 'EnableTransformControl',
    EnableLimitedTransformControl = 'EnableLimitedTransformControl',
    TransformControlDragged = 'TransformControlDragged',
    AdditionWithTransformControl = 'AdditionWithTransformControl',
    DisableTransformControl = 'DisableTransformControl',
    No = 'No',
}